import { CascadiaButtonProps } from "@certn/cascadia/components/button/types";
import { AriaButtonProps } from "react-aria";

import { _Button, ButtonProps } from "./_Button";

interface Props extends CascadiaButtonProps {
  border?: ButtonProps["border"];
  fill?: ButtonProps["fill"];
  fullWidth?: ButtonProps["fullWidth"];
  hoverFill?: ButtonProps["hoverFill"];
  href?: AriaButtonProps["href"];
  iconColor?: ButtonProps["iconColor"];
  iconSize?: ButtonProps["iconSize"];
  iconType?: ButtonProps["iconType"];
  slot?: string;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function GhostButton({ hoverFill, slot, ...props }: Props) {
  const { testID = "ghost-button" } = props;

  return (
    <_Button
      color="text-base"
      focusStyle="focus-action"
      hoverFill={hoverFill ? hoverFill : "background-ghost-hover"}
      iconColor="icon-base"
      loaderColor="icon-success"
      testID={testID}
      slot={slot}
      {...props}
    />
  );
}
